import MediaPlayerConfig from '../config/media-player-config';
import PlayerTypeConfig from '../config/player-type-config';

/**
 *
 * @module MediaConfigUtils
 * @desc A utility to help with creating the MediaPlayerConfig and PlayerTypeConfig objects
 * @class MediaConfigUtils
 *
 */
class MediaConfigUtils {

    /**
     *
     * @param {Object} config Object a JSON object of top-level configuration. This can include
     * a property `playerTypeConfig` that will create a PlayerTypeConfig object.
     * @static
     *
     */
    static create(config) {

        return MediaConfigUtils.createMediaPlayerConfig(config);

    }

    /**
     *
     * @desc Creates a MediaPlayerConfig object
     * @param {JSON} config The JSON data to create a MediaPlayerConfig object with
     * @static
     *
     */
    static createMediaPlayerConfig(config) {

        const mediaPlayerConfig = new MediaPlayerConfig(config);

        return mediaPlayerConfig;

    }

    /**
     *
     * @desc Creates a PlayerTypeConfig object. Pass a JSON object with a`playerTypeConfig`
     * property to provide the data to the PlayerTypeConfig object.
     * @param {JSON} config The data to create a PlayerTypeConfig object with
     * @static
     *
     */
    static createPlayerTypeConfig(config) {

        return new PlayerTypeConfig(config);

    }

}

export default MediaConfigUtils;
